import { AbstractLocalDataAccessLayer } from "@/lib/utility/data/local-data-access-layer.abstract";
import { IPartnerFleetUser, PartnerFleetUser } from "@/models/user.entity";

export const PartnerFleetUserAccessLayer = new (class extends AbstractLocalDataAccessLayer<IPartnerFleetUser> {
  getIdentifier(entity: IPartnerFleetUser): string {
    return entity.id;
  }

  protected mapEntity(entity: IPartnerFleetUser): IPartnerFleetUser {
    return new PartnerFleetUser(entity);
  }
})();
